var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E0F0C",
    d: "M18.343 9.543 9.77.972a.83.83 0 0 0-1.2 0L0 9.542l1.2 1.2L8.314 3.63v17.657h1.715V3.63l7.114 7.114z"
  })));
};
export default SvgArrowUp;